import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Grid.css';

/*

  Layouts

  * (1) SideNav + MainContainer
  * (2) SideNav + SecondLevel + MainContainer
  * (3) StepTrackerContainer + MainContainer
  * (4) StepTrackerContainer + LeftSection + MainContainer
  * (5) StepTrackerContainer + LeftSection + MainContainer + RightSection
  * (6) StepTrackerContainer + MapSection + MainContainer
  * (7) StepTrackerContainer + MainContainer + RightSection
  * (8) LeftSection + MainContainer + RightSection
  * (9) LeftSection + MainContainer
  * (10) MainContainer + RightSection
  * (11) FullWidth
  * (12) VerticalSectionMarker + MainContainer

  Note: If there's any problem regarding HTML structure, please consult GridStories.js

*/

export const allowedLayouts = {
  'side_main': 1,
  'side_second_main': 2,
  'step_main': 3,
  'step_left_main': 4,
  'step_left_main_right': 5,
  'step_map_main': 6,
  'step_main_right': 7,
  'left_main_right': 8,
  'left_main': 9,
  'main_right': 10,
  'full': 11,
  'vsm_main': 12,
};

class Grid extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.string,
    layout: PropTypes.oneOf(Object.values(allowedLayouts))
  };

  static defaultProps = { classes: '' };

  preventInvalidChildren(blockAmount, minimum) {
    if (blockAmount < minimum) {
      throw `This layout requires ${minimum} blocks, only ${blockAmount} were provided.`;
    }
  }

  parseGridInnerHTML = () => {
    const { children, layout } = this.props;
    const blocks = React.Children.toArray(children);
    let result = null;

    switch (layout) {
      case 5:
        this.preventInvalidChildren(blocks.length, 4);

        result = blocks;
        break;
      case 6:
        this.preventInvalidChildren(blocks.length, 3);

        result = blocks;
        break;

      default:
        result = blocks;

        break;
    }

    return result;
  }

  render() {
    const { classes, layout } = this.props;

    return (
      <article styles={styles.article} className={`grid layout-${layout} ${classes}`}>
        <div className="row">
          { this.parseGridInnerHTML() }
        </div>
      </article>
    );
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/uis/foundations/Grids/Grid.js